export default "__VITE_ASSET__15103009__"